import { FC } from 'react';
import styled from '@emotion/styled';
import type { DTOWebExclusiveBannerTextModule } from 'src/apis/dto/DTOShopModule';
import IcCheckBold from 'src/assets/images/icCheckBold.svg';
const BannerContainer = styled.div`
  position: relative;
  margin: 16px 16px 8px;
  padding: 32px 24px 20px;
  border: 2px solid ${({
  theme
}) => theme.color.accentF1};
  border-radius: 16px;

  ${({
  theme
}) => theme.screenSize.mobile} {
    padding-top: 24px;
  }
`;
const LabelBadge = styled.div`
  position: absolute;
  top: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
  ${({
  theme
}) => theme.isRtl && `transform: translate(50%, -50%);`}
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  background-color: ${({
  theme
}) => theme.color.bg1};
  border-radius: 8px;
`;
const WebExclusiveIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const IconImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  ${({
  theme
}) => theme.isRtl && 'transform: scaleX(-1);'}
`;
const LabelText = styled.span`
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  color: ${({
  theme
}) => theme.color.primary1};
  white-space: nowrap;
`;
const BenefitList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;
const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
const CheckIconWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  align-self: flex-start;
`;
const CheckIcon = styled(IcCheckBold)`
  width: 12px;
  height: 12px;
  color: ${({
  theme
}) => theme.color.contentDeep};
`;
const BenefitText = styled.span`
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  color: ${({
  theme
}) => theme.color.contentDeep};
  text-align: center;
`;
interface Props {
  title?: string;
  iconUrl?: string;
  modules?: DTOWebExclusiveBannerTextModule[];
}
const WebExclusiveBanner: FC<Props> = ({
  title,
  iconUrl,
  modules
}) => {
  if (!modules || modules.length === 0) return null;
  return <BannerContainer data-sentry-element="BannerContainer" data-sentry-component="WebExclusiveBanner" data-sentry-source-file="WebExclusiveBanner.tsx">
      {title && <LabelBadge>
          {iconUrl && <WebExclusiveIcon>
              <IconImage src={iconUrl} alt='' />
            </WebExclusiveIcon>}
          <LabelText>{title}</LabelText>
        </LabelBadge>}
      <BenefitList data-sentry-element="BenefitList" data-sentry-source-file="WebExclusiveBanner.tsx">
        {modules.map(module => <BenefitItem key={module.moduleId}>
            <CheckIconWrapper>
              <CheckIcon />
            </CheckIconWrapper>
            <BenefitText>{module.text}</BenefitText>
          </BenefitItem>)}
      </BenefitList>
    </BannerContainer>;
};
export default WebExclusiveBanner;